import { ORDER_STATUS_LABELS_UZ } from '@autoservice/shared';
import type { Status } from '../types';

const STATUS_ICONS: Record<Status, string> = {
  CREATED: '🆕',
  DIAGNOSTIC: '🔍',
  REPAIRING: '🔧',
  WAITING_PARTS: '⏳',
  READY: '✅',
  DELIVERED: '🏁',
  CANCELLED: '❌',
};

export function StatusBadge({ status }: { status: Status }) {
  return (
    <span className={`badge badge-${status}`}>
      <span style={{ marginRight: 4 }}>{STATUS_ICONS[status]}</span>
      {ORDER_STATUS_LABELS_UZ[status]}
    </span>
  );
}

export function getStatusIcon(status: Status): string {
  return STATUS_ICONS[status] ?? '•';
}

export function getStatusLabel(status: Status): string {
  return ORDER_STATUS_LABELS_UZ[status] ?? status;
}

export const KANBAN_STATUSES: Status[] = [
  'CREATED',
  'DIAGNOSTIC',
  'REPAIRING',
  'WAITING_PARTS',
  'READY',
  'DELIVERED',
];
